import type { FileRejection } from 'react-dropzone'

export const codeMessages = {
  'file-invalid-type': 'File type is not supported.',
  'too-many-files': 'Multiple files upload is not supporterd.',
}

export const getRejectionErrors = (
  rejectedFiles: FileRejection[],
  enhancedCodeMessages?: Record<string, string>,
) => {
  const codes: any = { ...codeMessages, ...enhancedCodeMessages }

  return rejectedFiles.map((rejectedFile) => {
    const fileErrors = rejectedFile.errors.map((error) => {
      return codes[error.code] || error.message || 'Upload error.'
    })

    return `"${rejectedFile.file.name}": ${fileErrors.join(' ')}`
  })
}
